var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDpLogoAndTextGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 33,
    viewBox: "0 0 223 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0221 0.759065C28.0221 0.759065 18.0605 0.525359 18.0605 9.96626C18.0605 15.5631 22.5551 19.2984 25.9846 21.6233C26.6866 22.0988 27.5056 22.4655 28.0221 22.4655C28.5385 22.4655 29.3575 22.1028 30.0596 21.6233C33.489 19.2984 37.9876 15.5631 37.9876 9.96626C37.9876 0.525359 28.0261 0.759065 28.0221 0.759065ZM28.0221 13.9231C25.682 13.9231 23.7857 12.0293 23.7857 9.69226C23.7857 7.35521 25.682 5.46138 28.0221 5.46138C30.3622 5.46138 32.2584 7.35521 32.2584 9.69226C32.2584 12.0293 30.3622 13.9231 28.0221 13.9231Z",
    fill: "url(#paint0_linear_35_1263)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3282 0.767963C17.7702 0.767963 17.7702 0.767963 17.7702 2.70611L17.7823 9.1854C16.5437 8.6656 15.2123 8.39966 13.8687 8.39966C8.41793 8.39563 4 12.691 4 17.9856C4 23.2803 8.41793 27.5716 13.8687 27.5716C15.2849 27.5716 16.6284 27.2815 17.8428 26.7617C18.0002 27.5716 18.5731 27.5716 20.6832 27.5716C23.7374 27.5716 23.7374 27.5716 23.7374 25.4682V2.77461L20.3282 0.699463V0.767963ZM14.2924 22.0271C12.0814 22.0271 10.29 20.2381 10.29 18.0299C10.29 15.8218 12.0814 14.0328 14.2924 14.0328C16.5033 14.0328 18.2947 15.8218 18.2947 18.0299C18.2907 20.2381 16.4993 22.0271 14.2924 22.0271Z",
    fill: "url(#paint1_linear_35_1263)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M28.0141 25.3949C26.489 25.4151 25.2544 25.7817 25.2625 26.2129C25.2665 26.644 26.5092 26.9785 28.0383 26.9543C29.5634 26.9341 30.798 26.5675 30.7899 26.1363C30.7818 25.7092 29.5392 25.3748 28.0141 25.3949Z",
    fill: "url(#paint2_linear_35_1263)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53 27.262C53 18.4326 53 9.60313 53 0.773682C53.2232 0.773682 53.3347 0.773682 53.5579 0.773682C57.1286 0.773682 60.6992 0.773682 64.2698 0.88405C70.7416 0.994418 75.8744 5.18841 76.9903 11.369C77.8829 15.7837 76.8787 19.8674 73.7544 23.2888C71.6343 25.4961 68.9563 26.7102 65.9436 27.1517C64.9393 27.262 63.9351 27.3724 62.8193 27.3724C59.8065 27.3724 56.7938 27.3724 53.7811 27.3724C53.5579 27.262 53.2232 27.262 53 27.262ZM59.2486 22.4058C61.1455 22.4058 62.9308 22.5162 64.7162 22.4058C67.5057 22.0747 69.2911 20.5296 70.1837 17.9911C71.0764 15.4526 71.0764 12.8038 70.1837 10.2653C69.1795 7.50614 67.171 5.96098 64.2698 5.62988C62.5961 5.51951 60.9224 5.62988 59.2486 5.62988C59.2486 5.62988 59.137 5.62988 59.137 5.74025C59.2486 11.2587 59.2486 16.8874 59.2486 22.4058Z",
    fill: "url(#paint3_linear_35_1263)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.129 0.883301C136.352 0.883301 136.575 0.883301 136.799 0.883301C140.035 0.883301 143.382 0.883301 146.618 0.993669C148.069 1.10404 149.519 1.32477 150.858 1.65588C154.54 2.75956 156.437 5.51876 156.437 9.49202C156.437 13.686 154.317 16.6659 150.189 17.7696C148.85 18.1007 147.511 18.2111 146.06 18.3215C144.833 18.4318 143.605 18.3215 142.266 18.3215C142.266 21.3014 142.266 24.171 142.266 27.1509C140.146 27.1509 138.026 27.1509 136.018 27.1509C136.129 18.4318 136.129 9.71275 136.129 0.883301ZM142.378 13.686C143.828 13.686 145.279 13.7964 146.73 13.686C148.626 13.5756 149.742 12.472 149.965 10.7061C150.077 10.1542 150.077 9.60238 150.077 9.05054C149.965 7.17428 148.85 5.84987 146.953 5.62913C145.502 5.40839 143.94 5.51876 142.489 5.51876L142.378 5.62913C142.378 8.1676 142.378 10.8164 142.378 13.3549C142.378 13.4653 142.378 13.5756 142.378 13.686Z",
    fill: "url(#paint4_linear_35_1263)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.172 10.4849C120.842 9.93305 121.511 9.38121 122.181 8.93974C125.417 7.06348 129.88 7.39458 131.889 11.8093C133.674 15.7826 133.674 19.8662 131.331 23.7291C129.545 26.709 126.198 28.0334 122.962 27.1505C122.181 26.9297 121.4 26.4883 120.507 26.0468C120.507 27.1505 120.507 28.3645 120.507 29.4682C120.507 30.5719 120.507 31.7859 120.507 33C118.61 33 116.713 33 114.816 33C114.816 24.7224 114.816 16.5551 114.816 8.27753C116.155 8.27753 117.494 8.16716 118.833 8.27753C119.168 8.27753 119.503 8.82937 119.726 9.16047C119.949 9.60195 120.061 10.1538 120.172 10.4849ZM120.507 18.1003C120.507 19.3143 120.507 20.418 120.507 21.6321C120.507 21.8528 120.619 22.1839 120.73 22.2943C122.292 24.0602 125.417 23.6187 126.309 21.4113C127.425 18.8729 127.314 16.3344 126.421 13.9063C126.086 12.8026 125.194 12.3612 123.966 12.3612C122.627 12.3612 121.623 12.8026 120.73 13.7959C120.619 14.0167 120.507 14.3478 120.396 14.5685C120.507 15.7826 120.507 16.9966 120.507 18.1003Z",
    fill: "url(#paint5_linear_35_1263)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M176.633 18.1001C176.41 19.2037 176.298 20.4178 175.964 21.4111C175.071 24.1703 173.174 26.0466 170.385 26.9295C167.818 27.8125 165.252 27.7021 162.797 26.8191C160.231 25.8258 158.557 24.0599 157.664 21.6318C156.883 19.3141 156.771 16.886 157.553 14.4579C158.445 11.5883 160.342 9.60172 163.243 8.60841C167.037 7.50473 170.608 7.83583 173.62 10.4847C175.517 12.1402 176.298 14.4579 176.41 16.886C176.522 17.4379 176.522 17.769 176.633 18.1001ZM170.719 18.2104C170.608 17.1068 170.608 16.3342 170.496 15.5616C170.385 15.2305 170.273 14.789 170.161 14.4579C169.603 13.0231 168.599 12.3609 166.925 12.3609C165.252 12.3609 164.136 13.0231 163.578 14.4579C162.797 16.7757 162.797 19.0934 163.578 21.3007C164.136 22.7355 165.252 23.3977 167.037 23.3977C168.599 23.3977 169.715 22.6252 170.161 21.1904C170.385 20.1971 170.496 19.0934 170.719 18.2104Z",
    fill: "url(#paint6_linear_35_1263)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112.139 17.8797C112.139 20.6389 111.357 23.1773 109.349 25.0536C107.675 26.5987 105.667 27.3713 103.324 27.4817C100.199 27.7024 97.4097 26.9298 95.2896 24.7225C94.2854 23.6188 93.5043 22.4047 93.1695 20.8596C92.6116 18.7626 92.6116 16.6656 93.1695 14.5686C94.0622 11.699 95.8475 9.71241 98.7487 8.71909C101.203 7.83615 103.881 7.83615 106.336 8.71909C109.907 10.0435 111.692 12.6923 112.139 16.3345C112.139 16.5552 112.25 16.8863 112.25 17.1071C112.139 17.4382 112.139 17.6589 112.139 17.8797ZM98.4139 17.8797C98.6371 18.9833 98.7487 20.1974 99.195 21.4114C99.7529 22.9566 101.092 23.3981 102.542 23.3981C103.993 23.3981 105.109 22.7358 105.667 21.4114C106.448 19.0937 106.559 16.776 105.667 14.5686C105.109 13.1338 103.993 12.4716 102.319 12.4716C100.757 12.4716 99.5297 13.1338 99.0834 14.5686C98.7487 15.5619 98.6371 16.776 98.4139 17.8797Z",
    fill: "url(#paint7_linear_35_1263)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M194.934 27.1503C194.934 27.1503 189.131 27.1503 188.908 27.1503V8.38771C190.47 8.38771 191.698 8.38771 192.925 8.38771C193.483 8.38771 193.706 8.71881 193.929 9.27065C194.041 9.60176 194.153 9.93286 194.264 10.3743C194.599 10.1536 194.934 9.8225 195.157 9.71213C197.054 8.27734 199.174 7.83587 201.405 8.38771C203.972 8.93955 205.646 10.8158 206.092 13.575C206.203 14.1269 206.204 14.6787 206.204 15.3409V26.9296C206.315 27.0399 206.315 27.5918 206.315 27.5918H200.624V26.7088V15.8927C200.736 15.5616 200.736 15.3409 200.624 15.0098C200.401 13.0232 199.174 12.0299 197.277 12.5817C196.496 12.8024 195.715 13.3543 195.045 13.7957C194.934 13.9061 194.822 14.2372 194.934 14.458V26.5985V27.1503Z",
    fill: "url(#paint8_linear_35_1263)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M211.112 12.4715C210.554 12.4715 210.108 12.4715 209.662 12.4715C208.881 12.4715 208.546 12.0301 208.546 11.2575C208.546 10.5953 208.546 9.8227 208.546 9.05012C209.439 8.82939 210.22 8.71902 211.112 8.49828C211.447 8.38791 211.67 8.27755 211.67 7.94644C212.005 6.62202 212.34 5.29761 212.674 3.97319C212.898 3.09024 213.121 2.97987 214.013 2.86951C215.018 2.86951 215.91 2.86951 216.915 2.86951C216.915 4.74577 216.915 6.62202 216.915 8.49828C218.588 8.49828 220.15 8.49828 221.713 8.49828C221.713 9.8227 221.713 11.0367 221.713 12.3612C220.15 12.3612 218.588 12.3612 216.915 12.3612C216.915 12.6923 216.915 12.8026 216.915 13.0234C216.915 15.7826 216.915 18.5418 216.915 21.1906C216.915 21.301 216.915 21.5217 216.915 21.6321C217.026 22.9565 217.807 23.398 219.035 22.8461C219.704 22.515 220.039 22.6254 220.374 23.1772C220.932 23.9498 221.378 24.8328 221.936 25.6053C221.936 25.7157 221.936 25.7157 222.047 25.9364C221.266 26.2676 220.597 26.709 219.704 26.9298C218.365 27.3712 216.915 27.4816 215.464 27.3712C213.009 27.0401 211.224 25.0535 211.112 22.4047C211.001 19.204 211.112 16.1137 211.112 12.913C211.112 13.0234 211.112 12.6923 211.112 12.4715Z",
    fill: "url(#paint9_linear_35_1263)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5823 27.151C83.5738 27.151 81.7884 27.151 79.8915 27.151C79.8915 20.86 79.8915 14.6794 79.8915 8.38837C81.2305 8.38837 82.5695 8.38837 83.9085 8.38837C84.3548 8.38837 84.6896 8.71947 84.8012 9.27131C84.9128 9.82315 85.0243 10.4854 85.1359 11.0372C85.6938 10.375 86.2517 9.71278 86.8097 9.16094C88.0371 7.94689 89.934 7.61579 91.3845 8.278C91.7193 8.49873 91.9425 8.6091 91.9425 9.16094C91.8309 10.2646 91.7193 11.3683 91.6077 12.5824C91.4961 13.3549 91.273 13.5757 90.3803 13.5757C89.7108 13.4653 88.9297 13.4653 88.1487 13.4653C86.8097 13.5757 85.4707 15.0105 85.4707 16.4452C85.4707 19.8667 85.4707 23.1777 85.4707 26.5991C85.5823 26.7095 85.5823 26.9302 85.5823 27.151Z",
    fill: "url(#paint10_linear_35_1263)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M185.114 27.1505C183.217 27.1505 181.32 27.1505 179.423 27.1505C179.423 20.8596 179.423 14.5686 179.423 8.27759C181.32 8.27759 183.217 8.27759 185.114 8.27759C185.114 14.5686 185.114 20.8596 185.114 27.1505Z",
    fill: "url(#paint11_linear_35_1263)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M182.459 0C184.356 0 185.918 1.54515 185.918 3.31104C185.918 5.07693 184.356 6.51172 182.459 6.51172C180.562 6.51172 179 4.96657 179 3.20068C179 1.43479 180.562 0 182.459 0Z",
    fill: "#49BE65"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35_1263",
    x1: 27.9781,
    y1: -3.49602,
    x2: 27.9781,
    y2: 24.4714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78F36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_35_1263",
    x1: 13.991,
    y1: -5.99221,
    x2: 13.8688,
    y2: 27.5716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FCF6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169A50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_35_1263",
    x1: 27.9989,
    y1: 24.3035,
    x2: 28.003,
    y2: 27.9955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5A623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_35_1263",
    x1: 65.1512,
    y1: 0.773682,
    x2: 65.1512,
    y2: 27.3724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EC267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D944A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_35_1263",
    x1: 146.227,
    y1: 0.883301,
    x2: 146.227,
    y2: 27.1509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EC267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D944A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_35_1263",
    x1: 123.991,
    y1: 7.85864,
    x2: 123.991,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EC267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D944A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_35_1263",
    x1: 166.826,
    y1: 8.01465,
    x2: 166.826,
    y2: 27.5391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EC267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D944A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_35_1263",
    x1: 102.501,
    y1: 8.05688,
    x2: 102.501,
    y2: 27.5179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EC267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D944A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_35_1263",
    x1: 197.612,
    y1: 8.15778,
    x2: 197.612,
    y2: 27.5918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EC267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D944A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_35_1263",
    x1: 215.297,
    y1: 2.86951,
    x2: 215.297,
    y2: 27.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EC267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D944A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_35_1263",
    x1: 85.917,
    y1: 7.94269,
    x2: 85.917,
    y2: 27.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EC267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D944A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_35_1263",
    x1: 182.268,
    y1: 8.27759,
    x2: 182.268,
    y2: 27.1505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EC267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D944A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDpLogoAndTextGreen);
export default __webpack_public_path__ + "static/media/dp-logo-and-text-green.8414cfa4bf62f8586cb056d57aa0012c.svg";
export { ForwardRef as ReactComponent };